import $ from 'jquery';

export default () => {
  $('.loginAccess__trigger').on('click', function(evt) {
    evt.preventDefault();
    $('.u-overlay').toggleClass('is-active');
    $('#LoginAccess').toggleClass('is-active');
  });

  $('.requestAQuote__trigger').on('click', function(evt) {
    evt.preventDefault();
    $('.u-overlay').toggleClass('is-active');
    $('#RequestAQuote').toggleClass('is-active');
  });
}



// WEBPACK FOOTER //
// ./themes/app/assets/js/modules/requestQuote.js